if (!customElements.get('rotating-text-bar')) {
  class RotatingTextBar extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      
        const bullets = document.getElementsByClassName("rotating-text-item");
        var index = 0;
        bullets[0].style.display = "flex";
        const nextBullet = () => {
          bullets[index].style.display = "none";
          index = (index + 1) % bullets.length;
          bullets[index].style.display = "flex";
          console.log('fired index: ' + index);
          setTimeout(nextBullet, this.dataset.readTime);
        }
        
        setTimeout(nextBullet, this.dataset.readTime);
      
    }

  }

  customElements.define('rotating-text-bar', RotatingTextBar);
}
